import {
  SwitchContextBodySchema,
  SwitchContextResponseSchema,
  type SwitchContextBody,
  type SwitchContextResponse,
} from '@zrsystem/contracts';

import { getHttpClient } from '@/shared/api/http-client.js';

export async function switchContextRequest(
  body: SwitchContextBody,
): Promise<SwitchContextResponse> {
  const payload = SwitchContextBodySchema.parse(body);
  const response = await getHttpClient().post<unknown>('/api/auth/switch-context', payload, {
    skipPlace: true,
    feedback: 'error-only',
  });
  return SwitchContextResponseSchema.parse(response);
}
